import { Picture } from "../../../Components/PhotosApp/PhotoViewer/PhotoInterfaces";
import Profile_1 from "./DublinTweeterAssets/Tweeter-Pfp-01.webp";
import Profile_2 from "./DublinTweeterAssets/Tweeter-Pfp-02.webp";
import ContentPicture_1 from "./DublinTweeterAssets/Tweeter-PostPic.webp";

export interface Comment {
  icon?: string;
  date: string;
  author: string;
  handle: string;
  likes: number;
  content: string;
}

export interface Tweet {
  icon?: string;
  date: string;
  time: string;
  author: string;
  handle: string;
  verified: string;
  content: string | Picture;
  contentImage?: string;
  likes: number;
  retweets: number;
  quotes: number;
  comments?: Comment[];
}

export const DublinTweetContent: Tweet[] = [
  {
    icon: Profile_1,
    date: "24 April 2025",
    time: "3:48 PM",
    author: "Orla Hosseini",
    handle: "@0rla_h0sseini",
    verified: "Verified.webp",
    content:
      "Now is the time to expose @corneliusmarchand for the person he truly is. Share this to everyone you know, I want the whole world to know. Men like him must be stopped, particularly those in high positions. This needs to be front page news @globaltimesnews @dublin_press ! (1/5)",
    likes: 1,
    retweets: 0,
    quotes: 0,
  },
  {
    icon: Profile_1,
    date: "24 April 2025",
    time: "3:49 PM",
    author: "Orla Hosseini",
    handle: "@0rla_h0sseini",
    verified: "Verified.webp",
    content:
      "Cornelius Marchand, the show’s financier, got in touch with me a couple of weeks ago (his first message to me was sent on 11 April) to present me with what he called a ‘business proposal’. I assumed he just wanted to get into my pants, so I ignored him. He promised it was strictly business and we met up in a restaurant some days later. (2/5)",
    likes: 1,
    retweets: 0,
    quotes: 0,
  },
  {
    icon: Profile_1,
    date: "24 April 2025",
    time: "3:50 PM",
    author: "Orla Hosseini",
    handle: "@0rla_h0sseini",
    verified: "Verified.webp",
    content:
      "He explained he wanted @KendraCampbell dead. He wouldn’t tell me why. He told me he had a plan and multiple people were in on it, and that he’d give me more details closer to the time. He left me with a briefcase full of €250,000 in cash notes and told me my role was very low risk so he couldn’t pay me more than that. (3/5)",
    likes: 1,
    retweets: 0,
    quotes: 0,
  },
  {
    icon: Profile_1,
    date: "24 April 2025",
    time: "3:52 PM",
    author: "Orla Hosseini",
    handle: "@0rla_h0sseini",
    verified: "Verified.webp",
    content:
      "I played along pretending to agree to his crazy scheme. I didn't hear from him until this morning, when he arrived at my trailer door with a delivery of live ammunition. He wanted me to load the prop gun with real ammunition and hand it to Robbie to shoot Kendra with. (4/5)",
    likes: 1,
    retweets: 0,
    quotes: 0,
  },
  {
    icon: Profile_1,
    date: "24 April 2025",
    time: "3:53 PM",
    author: "Orla Hosseini",
    handle: "@0rla_h0sseini",
    verified: "Verified.webp",
    content:
      "Needless to say I didn’t go along with it. I have saved all the screenshots proving all of this and various photos and audios I took discreetly. I’m taking this to the law courts @corneliusmarchand (5/5)",
    contentImage: ContentPicture_1,
    likes: 1,
    retweets: 0,
    quotes: 0,
  },
  {
    icon: Profile_2,
    date: "24 April 2025",
    time: "6:04 PM",
    author: "What's On Dublin",
    handle: "@whatsondublin",
    verified: "Verified.webp",
    content:
      "Poor start to the season from @CelticSlayer and @DublinPhantoms with a loss to @LimaJaguars",
    likes: 1,
    retweets: 0,
    quotes: 0,
  },
  {
    icon: Profile_2,
    date: "23 April 2025",
    time: "4:07 PM",
    author: "What's On Dublin",
    handle: "@whatsondublin",
    verified: "Verified.webp",
    content:
      "Tomorrow, the @DublinPhantoms start their defence of last season’s victorious @CombatOpsGames league campaign. Coverage from 2pm to 6pm local time.",
    likes: 1,
    retweets: 0,
    quotes: 0,
  },
];
